<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class='login-page' fxFill fxLayout='column' fxLayoutAlign='center center'>
    <ng-container *ngIf='!(loginInProgress$|async); then formTemplate; else spinnerTemplate'></ng-container>
    -->
</div>

<ng-template #spinnerTemplate>
    <mat-card class='login-spinner-card mat-elevation-z2'>
        <mat-toolbar color='primary' fxLayout='row' fxLayoutAlign='start center'>
            <h2 class='mat-toolbar-tools'>Logging in...</h2>
        </mat-toolbar>
        <mat-card-content fxLayout='column' fxLayoutAlign='center center'>
            <mat-spinner class="login-spinner" mode="indeterminate"></mat-spinner>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #formTemplate>
    <mat-card class='login-card mat-elevation-z2'>
        <mat-toolbar color='primary' fxLayout='row' fxLayoutAlign='start center'>
            <h2 class='mat-toolbar-tools'>Login</h2>
        </mat-toolbar>
        <mat-card-content cdkTrapFocus>
            <form name='loginForm' (ngSubmit)='doLogin()' [formGroup]='loginForm' novalidate>
                <ng-container *ngFor='let auth of (authenticators$ | async)'>
                    <ng-container [ngSwitch]='auth'>

                        <ng-container *ngSwitchCase="'password'">
                            <ng-container *ngTemplateOutlet='passwordForm'></ng-container>
                        </ng-container>

                        <ng-container *ngSwitchCase="'oidc'">
                            <ng-container *ngTemplateOutlet='oidcForm'></ng-container>
                        </ng-container>

                    </ng-container>
                </ng-container>

                <div *ngIf='enableRemember$ | async' class='remember-me'>
                    <mat-checkbox formControlName='rememberMe' aria-label='Remember me'>
                        Remember me
                    </mat-checkbox>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #passwordForm>
    <div>
        <div fxLayout='column' cdkTrapFocus cdkTrapFocusAutoCapture='true'>

            <mat-form-field appearance='standard' hideRequiredMarker='true'>
                <mat-label>Username:</mat-label>
                <input matInput type='text'
                       name='username'
                       [formControl]="loginForm.get('username')" placeholder='Username'
                       autocomplete='username'
                       cdkFocusInitial />
            </mat-form-field>

            <mat-form-field appearance='standard'>
                <mat-label>Password:</mat-label>
                <input matInput type='password'
                       name='password'
                       [formControl]="loginForm.get('password')"
                       placeholder='Password' autocomplete='current-password' />
            </mat-form-field>

            <div *ngIf='invalidLogin'
                 class='mat-error' role='alert'>
                Login failed. Please try again.
            </div>
        </div>

    </div>

    <div class='login-actions' fxLayout='column' fxLayoutAlign='space-between stretch'>

        <button mat-raised-button color='primary' type='submit' [disabled]='!loginForm.valid'>
            Login
        </button>

        <ng-container *ngIf='autoLogin$ | async; let autoLogin'>
            <button mat-button color='primary'
                    type='button'
                    (click)='guestLogin()'
                    *ngIf='autoLogin.guestuser && autoLogin.guestpassword'>
                Login as Guest
            </button>
        </ng-container>

        <ng-container *ngIf='needsForgotPassword$ | async'>
            <button mat-button
                    color='accent'
                    class='button-link'
                    (click)='forgotPassword()'>I forgot my password</button>
        </ng-container>
    </div>
</ng-template>

<ng-template #oidcForm>

    <div class='login-actions' fxLayout='column' fxLayoutAlign='space-between stretch'>
        <button mat-raised-button color='primary' type='button' class='open-id-button' (click)='oauthLogin()'>
            {{ openIdButtonText$ | async }}
        </button>
    </div>

</ng-template>
